import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback, useEffect } from 'react';
const AuthContext = createContext(undefined);
const STORAGE_KEY = 'bp-status-auth';
export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => {
        if (typeof window === 'undefined')
            return null;
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (!stored)
            return null;
        try {
            const parsed = JSON.parse(stored);
            return parsed.token ?? null;
        }
        catch {
            return null;
        }
    });
    const [user, setUser] = useState(() => {
        if (typeof window === 'undefined')
            return null;
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (!stored)
            return null;
        try {
            const parsed = JSON.parse(stored);
            return parsed.user ?? null;
        }
        catch {
            return null;
        }
    });
    useEffect(() => {
        if (token && user) {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, user }));
        }
        else {
            window.localStorage.removeItem(STORAGE_KEY);
        }
    }, [token, user]);
    const login = useCallback((payload) => {
        setToken(payload.token);
        setUser(payload.user);
    }, []);
    const logout = useCallback(() => {
        setToken(null);
        setUser(null);
    }, []);
    const updateUser = useCallback((updated) => {
        setUser(updated);
    }, []);
    return (_jsx(AuthContext.Provider, { value: { token, user, login, logout, updateUser }, children: children }));
};
export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};
